import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import Login from './pages/Login';
import MainLayout from './layouts/MainLayout';
import ApartmentList from './pages/ApartmentList';
import UserManagement from './pages/UserManagement';
import BannerManagement from './pages/BannerManagement';
import UserMessages from './pages/UserMessages';
import PhraseSettings from './pages/PhraseSettings';
import './App.css';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Navigate to="/apartments" replace />} />
            <Route path="apartments" element={<ApartmentList />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="banners" element={<BannerManagement />} />
            <Route path="messages" element={<UserMessages />} />
            <Route path="phrases" element={<PhraseSettings />} />
          </Route>
        </Routes>
      </Router>
    </ConfigProvider>
  );
}

export default App;

